import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {DamageImageModel} from '../models/underwriter.model';

@Injectable({
  providedIn: 'root'
})
export class DamageQuestionPasser {
  private subject = new Subject<DamageImageModel>();
  showDamageImageModalSubject = new BehaviorSubject(false);
  showDamageImageModalObservable = this.showDamageImageModalSubject.asObservable();
  showDamageImageAltModalSubject = new BehaviorSubject(false);
  showDamageImageAltModalObservable = this.showDamageImageAltModalSubject.asObservable();

  passDamageQuestion(damageQuestion: DamageImageModel): void {
    this.subject.next(damageQuestion);
  }

  updateComponent(): Observable<DamageImageModel> {
    return this.subject.asObservable();
  }

  setDamageImageModal(value: boolean): void {
    this.showDamageImageModalSubject.next(value);
  }

  setDamageImageModalAlt(value: boolean): void {
    this.showDamageImageAltModalSubject.next(value);
  }
}
